import React, { useEffect, useState } from "react";
import axios from "axios";
import global from "../../global-variables";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { BsChevronRight } from "react-icons/bs";
import Header from "../layout/header";
import { Container, Row, Col } from "reactstrap";
import { json, useParams } from "react-router-dom";
import Parser from "html-react-parser";
import globalVariables from "../../global-variables";
import $ from "jquery";
import WOW from "wowjs";
import Metatag from '../../hooks/Metatag'
export default function Searchresults() {
  // secation name initialise
  let val_section_name = "";
  let bln_ul_opened = false;
  let _str_html = "";

  //Getting id from url
  let { str } = useParams();
  const qs_str = str;
    
  const [search, setSearchList] = useState([]);
  
  useEffect(() => {
    let _obj = new Object();
    _obj.searchstr = qs_str;
    setTimeout(() => {
      axios
        .post(global.variables.strApiUrl + "/searchApi/searchApi", _obj)
        .then((response_list) => {
          // pass the result in the success function of the respective page
          setSearchList(response_list.data[0]);
        });
    }, 300);
  }, [qs_str]);

  useEffect(() => {
    // add class for home header and remove inner class
    $(".fixed-top").addClass("bg-header");

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();


  }, [qs_str]);

  return (
    <>
      <Header main_className="bg-header"></Header>
      <Metatag title={`Search results for ${qs_str}`} keywords={`Search results for ${qs_str}`} description={`Search results for ${qs_str}`}/>
      {/* Visual Container */}
      <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('./images/bg-events.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
        <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
        <div className="masthead d-flex align-items-center w-100">
          <Container className="px-4 px-md-5 pb-xl-5 py-4">
            <div className="d-flex align-items-end">
              <div className="m-0 d-sm-flex align-items-center">
                <h1 className="mb-0 fw-bold text-white text-uppercase">Search Results</h1>
                
              </div>
            </div>
          </Container>
        </div>
      </Container>

      {/* Body Panel */}
      
      <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
        <div className="border  rounded-3 p-5 list">
          <h4 className="text-dark mb-4">
            {" "}
            Search results for '{qs_str}' -{" "}
            <small>({search.length} Records found)</small>
          </h4>
          {search.length > 0
            ? search.map((val, index) => {
              
                // check if the section name doesnot match then
                if (val_section_name != val.section_name) {
                  // set the new section value
                  val_section_name = val.section_name;

                  // check if the previous ul is opened then close it and reset the variable
                  if (bln_ul_opened === true) {
                    _str_html += "</ul>";
                    bln_ul_opened = false;
                  }
                }

                // check if ul is not opened then open it and bind the section name and reset the variable
                if (bln_ul_opened === false) {
                  _str_html +=
                    "<h6 class='fw-bold' key='" +
                    index +
                    "'>" +
                    val.section_name +
                    "</h6>";
                  _str_html += "<ul class='mb-4'>";
                  bln_ul_opened = true;
                }

                // bind the li node for the result
                _str_html += "<li key='" + index + "'>";
                _str_html +=
                  "<a href='"+ globalVariables.variables.strDomainUrl + val.link + "'>" + val.result.replace(/<[^>]+>/g, '') + "</a>";
                _str_html += "</li>";
              })
            : null}

          <>{Parser(_str_html)}</>
        </div>
      </Container>
      

      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel">
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Search Results</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}
